import { Stack, styled } from "@mui/material";

export const Container = styled(Stack)(({ theme }) => ({
  padding: "0 1rem",
  backgroundColor: theme.palette.colors.gray.o10,
  flexGrow: 1,
  height: "100%",
  width: "17.5rem",
}));
